// data.js — content for Precision Woodworking Artistry
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_890a2e6d-3283-491a-aeac-3f76725a2a41/artifacts/dadlmip0_IMG_3509.jpg.jpg";

// Real work photos from Nikki
export const REAL = {
  branded_cutting_board:
    "https://customer-assets.emergentagent.com/job_precision-craft-21/artifacts/40u3qntu_Image%207-3-26%20at%2012.38%E2%80%AFPM.png",
  stacked_boxes:
    "https://customer-assets.emergentagent.com/job_precision-craft-21/artifacts/wspryya8_Image%207-3-26%20at%2012.39%E2%80%AFPM.png",
  coffee_grinder_stand:
    "https://customer-assets.emergentagent.com/job_precision-craft-21/artifacts/ebjko8qk_Image%207-3-26%20at%2012.38%E2%80%AFPM.png",
  rose_box:
    "https://customer-assets.emergentagent.com/job_precision-craft-21/artifacts/mispskbu_IMG_3712.jpg.jpg",
  slate_whisky:
    "https://customer-assets.emergentagent.com/job_precision-craft-21/artifacts/omg7xva2_IMG_3711.jpg.jpg",
  octagonal_board:
    "https://customer-assets.emergentagent.com/job_precision-craft-21/artifacts/ctcvf5af_Image%207-3-26%20at%201.05%E2%80%AFPM.png",
  box_stack_workshop:
    "https://customer-assets.emergentagent.com/job_precision-craft-21/artifacts/lyh2eabv_Image%207-3-26%20at%201.05%E2%80%AFPM%20%281%29.png",
  rolling_shelf:
    "https://customer-assets.emergentagent.com/job_precision-craft-21/artifacts/0i9qrbjr_Image%207-3-26%20at%201.06%E2%80%AFPM.png",
  paddle_board:
    "https://customer-assets.emergentagent.com/job_precision-craft-21/artifacts/nynyverb_Image%207-3-26%20at%201.04%E2%80%AFPM.png",
};

export const BRAND = {
  name: "Precision Woodworking Artistry",
  short: "Precision Woodworking",
  est: "EST 2018",
  phone: "305-982-7191",
  phoneTel: "+13059827191",
  email: "carpentry1977@yahoo.com",
  location: "South Florida",
};

export const NAV_LINKS = [
  { id: "home", label: "Home", href: "#home" },
  { id: "about", label: "About", href: "#about" },
  { id: "gallery", label: "Gallery", href: "#gallery" },
  { id: "process", label: "Process", href: "#process" },
  { id: "faq", label: "FAQ", href: "#faq" },
];

const px = (id, w = 1400, h = 900) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=${h}&w=${w}`;

// Featured gallery — all real work from Nikki's shop
export const GALLERY = [
  {
    key: "branded-cutting-board",
    title: "Signature Checkered End-Grain Board",
    caption: "Padauk & Maple · Branded",
    image: REAL.branded_cutting_board,
    featured: true,
  },
  {
    key: "octagonal-serving-board",
    title: "Octagonal Striped Serving Board",
    caption: "Purpleheart, Walnut & Maple · Branded",
    image: REAL.octagonal_board,
  },
  {
    key: "cherry-walnut-boxes",
    title: "Cherry & Walnut Keepsake Boxes",
    caption: "Contrasting Spline Joinery",
    image: REAL.stacked_boxes,
  },
  {
    key: "workshop-box-stack",
    title: "Mixed Hardwood Box Collection",
    caption: "Maple, Walnut, Cherry & Padauk",
    image: REAL.box_stack_workshop,
  },
  {
    key: "coffee-grinder-stand",
    title: "Vintage Grinder Display Base",
    caption: "Custom Wood Pedestal",
    image: REAL.coffee_grinder_stand,
  },
  {
    key: "rose-arrangement-box",
    title: "Floral Arrangement Box",
    caption: "Walnut Box on Cherry Board",
    image: REAL.rose_box,
  },
  {
    key: "slate-and-whisky",
    title: "Slate Chalkboard & Whisky Presenter",
    caption: "Curly Maple & Purpleheart",
    image: REAL.slate_whisky,
  },
  {
    key: "rolling-shop-cart",
    title: "Custom Rolling Storage Cart",
    caption: "Solid Wood · Mobile Design",
    image: REAL.rolling_shelf,
  },
  {
    key: "paddle-cutting-board",
    title: "Branded Paddle Cutting Board",
    caption: "Purpleheart & Maple · Signature Series",
    image: REAL.paddle_board,
  },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Consultation",
    body: "We listen first. Your vision, your space, your story — we map the project around how you actually live.",
  },
  {
    n: "02",
    title: "Design & Planning",
    body: "Detailed drawings, material samples, hardware selection, and a transparent quote. Nothing left to guess.",
  },
  {
    n: "03",
    title: "Craftsmanship",
    body: "Built by hand in our South Florida workshop using hardwoods, hand-fit joinery, and obsessive detail.",
  },
  {
    n: "04",
    title: "Delivery & Install",
    body: "White-glove delivery and professional installation. We don't leave until it's perfect.",
  },
];

export const WHY_POINTS = [
  { t: "Established 2018", b: "Hundreds of custom builds delivered across South Florida." },
  { t: "Custom, Never Cookie-Cutter", b: "Every piece is designed for your home and your life." },
  { t: "Detail-Obsessed Craftsmanship", b: "Hand-fit joinery, sanded by feel, finished by eye." },
  { t: "Durable, Honest Materials", b: "Solid hardwoods, premium hardware, finishes that age well." },
  { t: "Clear Communication", b: "Transparent quotes, regular updates, no surprises." },
  { t: "Built Around Your Vision", b: "We design with you — not at you." },
];

export const TESTIMONIALS = [
  {
    quote:
      "The custom dining table came out better than we imagined. The grain, the proportions, the finish — every detail was right. We get compliments every time someone walks in.",
    name: "Marcus & Elena R.",
    project: "Live-Edge Dining Table",
    location: "Fort Lauderdale, FL",
  },
  {
    quote:
      "Professional, detailed, and the quality is obvious the moment you touch it. They built a media wall for us that completely changed the room. Worth every dollar.",
    name: "Daniel P.",
    project: "Built-In Media Wall",
    location: "Miami, FL",
  },
  {
    quote:
      "They brought our idea to life perfectly. We came in with a Pinterest board and a weird closet. We walked away with a closet that feels like a boutique. Real craftsmen.",
    name: "Alex & Jordan T.",
    project: "Master Closet System",
    location: "Boca Raton, FL",
  },
  {
    quote:
      "I've worked with three woodworkers over the years. Precision is the first one who actually listened, returned calls, and over-delivered. The kitchen is stunning.",
    name: "Patricia M.",
    project: "Walnut Shaker Kitchen",
    location: "Delray Beach, FL",
  },
];

export const FAQS = [
  {
    key: "fully-custom",
    q: "Do you build fully custom pieces?",
    a: "Yes. Every project is custom — designed around your space, your style, and your budget. We don't sell off-the-shelf items.",
  },
  {
    key: "timeline",
    q: "How long does a project take?",
    a: "Most furniture pieces take 4–8 weeks. Larger projects like built-ins or full kitchens typically run 8–16 weeks. We'll give you an honest timeline up front.",
  },
  {
    key: "design-help",
    q: "Do you help with design ideas?",
    a: "Absolutely. Bring a Pinterest board, a sketch, or just a feeling. We'll translate it into detailed drawings, material samples, and a build plan you can approve before a single board is cut.",
  },
  {
    key: "installation",
    q: "Do you offer installation?",
    a: "Yes — full white-glove delivery and professional installation across South Florida. We handle the entire process from shop to your home.",
  },
  {
    key: "quote",
    q: "How do I get a quote?",
    a: "Fill out the quote form below or call us directly. We'll set up a free consultation, learn your project, and follow up with a detailed written quote.",
  },
];
